var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/product_short_banner_logo.6e4864d7.png","uri@2x": __webpack_public_path__ + "static/media/product_short_banner_logo.7c0e7955.png","uri@3x": __webpack_public_path__ + "static/media/product_short_banner_logo.3cbf881e.png",
    width: 97,
    height: 40
});